import React from "react";

import { IToolbarMenuItemProps } from "./ToolbarMenuItem";

import { IAuthProps } from "./AuthContext";
import withAuth from "./withAuth";

interface IOverflowMenuItemState {
    isCollapsed: boolean;
}

interface IOverflowMenuItemProps extends IAuthProps {
    icon?: string;
    displayText?: string;
    className?: string;
    dropdownClassName?: string;
}

class OverflowMenuItem extends React.Component<IOverflowMenuItemProps, IOverflowMenuItemState> {
    private blurTimer?: number;

    constructor(props: Readonly<IOverflowMenuItemProps>) {
        super(props);

        this.state = {
            isCollapsed: true,
        };

        this.toggleMenu = this.toggleMenu.bind(this);
        this.handleBlur = this.handleBlur.bind(this);
        this.handleFocus = this.handleFocus.bind(this);
    }

    public render() {
        let anyChildRendering = false;
        React.Children.forEach(this.props.children, child => {
            if (!React.isValidElement<IToolbarMenuItemProps>(child)) {
                return;
            }

            if ((child.props.condition === undefined || child.props.condition === true) && (child.props.right === undefined || this.props.authContext.hasRight(child.props.right))) {
                anyChildRendering = true;
            }
        });

        if (!anyChildRendering) {
            return "";
        }

        return (
            <span className={`${this.props.displayText ? "" : (`icon-${this.props.icon ? this.props.icon : "ellipsis-v"}`)} menu-btn-overflow ${this.props.className ? this.props.className : ""}`} tabIndex={0} role="button" title="Click to show more menu items" onClick={this.toggleMenu} onBlur={this.handleBlur} onFocus={this.handleFocus}>
                {this.props.displayText ? <i className={`icon-${this.props.icon ? this.props.icon : "ellipsis-v"}`} /> : undefined}
                {this.props.displayText ? <span>{this.props.displayText}</span> : ""}
                <div className={"toolbar-menu" + (this.state.isCollapsed ? " hidden" : "") + " " + this.props.dropdownClassName}>
                    {this.props.children}
                </div>
            </span>
        );
    }

    private toggleMenu() {
        this.setState(s => {
            return {
                isCollapsed: !s.isCollapsed
            };
        });
    }

    private handleBlur() {
        this.blurTimer = window.setTimeout(() => {
            this.setState({
                isCollapsed: true
            });
        }, 25);
    }

    private handleFocus() {
        if (this.blurTimer) {
            window.clearTimeout(this.blurTimer);
            this.blurTimer = undefined;
        }
    }
}

export default withAuth(OverflowMenuItem);
